import { HeaderLayoutConfig } from "ict24h-themes-react/lib/esm/components/UI/Header/Header";

export const CONFIG_WORKFLOW_APP_PREFIX_URL = "/config-workflows";
export const configHomeAppLayout: HeaderLayoutConfig = {
  appName: " ICT24h Demo Home App ",
  logoLink: "https://ict24h.net",
  backgroundColor: "#454791",
  color: "#000",
};
